export default {
    templateTypes: {},
    templateTypeContents: {},
    languages: [],
    survey: {},
    debugMode: false,
    activeLanguage: '',
    useHtml: '',
    currentTemplateType: '',
    permissions: {}
};
